export type PerUserChannelHandler = (data: unknown) => void

interface PerUserRealtimeChannel {
	bind(eventName: string, handler: PerUserChannelHandler): unknown
	unbind(eventName: string, handler: PerUserChannelHandler): unknown
}

interface PerUserRealtimeClient {
	subscribe(channelName: string): PerUserRealtimeChannel
	unsubscribe(channelName: string): unknown
}

interface ChannelEntry {
	channel: PerUserRealtimeChannel
	refCount: number
}

export class RefCountedUserChannelOwner {
	private readonly entries = new Map<string, ChannelEntry>()

	constructor(private readonly getClient: () => PerUserRealtimeClient) {}

	bind(
		userId: string,
		eventName: string,
		handler: PerUserChannelHandler,
	): () => void {
		const channelName = `private-user-${userId}`
		let entry = this.entries.get(channelName)
		if (!entry) {
			entry = {
				channel: this.getClient().subscribe(channelName),
				refCount: 0,
			}
			this.entries.set(channelName, entry)
		}

		entry.refCount += 1
		entry.channel.bind(eventName, handler)

		let released = false
		return () => {
			if (released) return
			released = true

			const current = this.entries.get(channelName)
			if (!current) return
			current.channel.unbind(eventName, handler)
			current.refCount -= 1
			if (current.refCount === 0) {
				this.entries.delete(channelName)
				this.getClient().unsubscribe(channelName)
			}
		}
	}
}
